function addFileUploaderData(form, formData)
{
    form.find('input[type="file"]').each(function () {
        let input = $(this);

        if (input.hasClass("inp-file-basic") || input.hasClass("inp-file-extended")) {

            let instance = input.data('instance');
            let files = instance.selectedFiles;
            let name = input.attr("name");

            if (files.length > 1) {
                for (let i = 0; i < files.length; i++) {
                    formData.append(name + "[]", files[i]);
                }
            } else {
                if (files.length === 1) {
                    formData.append(name, files[0]);
                }
            }
        }

    });
}

const allFileUploaderData = {
    counter: 1
};

const AbstractFileUploader = function (inputElement, settings) {

    let id = allFileUploaderData.counter;
    let input = inputElement;
    let container = null;
    let editable = false;

    let filesIdCounter = 1;
    let selectedFiles = [];
    let checkedFilesMessages = [];

    let allFilesCount = 0;
    let allFilesSize = 0;

    let defaultSettings = {
        maxFilesCount: null,
        maxPostSize: null,
        maxFileSize: null,
        disabledExtensions: [],
        allowedExtensions: [],
        preUpload: false,
        uploadUrl: null,
        messages: {
            selectFiles: "Vyberte soubor/y kliknutím do plochy nebo přetáhnutím souborů do plochy",
            selectSingleFile: "Vyberte soubor",
            selectMultipleFiles: "Vyberte soubor/y",
            selectedFile: "Vybrán {count} soubor",
            extensionNotAllowed: "Přípona souboru <b>{file}</b> nepatří mezi povolené",
            fileAlreadySelected: "Soubor <b>{file}</b> už je vložený",
            maxFilesCountExceeded: "Byl překročen maximální počet souborů, které lze naráz nahrát",
            maxPostSizeExceeded: "Byla překročena celkové velikost všech souborů, které lze naráz nahrát",
            fileSizeExceeded: "Soubor <b>{file}</b> je příliš velký"
        }
    };

    parseOptions(defaultSettings, settings);

    this.setInput = function (newInput) {
        input = newInput;
    };

    Object.defineProperties(this, {
        id: {
            get: function () {
                return id;
            }
        },
        input: {
            get: function () {
                return input;
            }
        },
        container: {
            get: function () {
                return container;
            },
            set: function (containerElem) {
                if (isObject(containerElem)) {
                    container = containerElem;
                }
            }
        },
        editable: {
            get: function () {
                return editable;
            },
            set: function (isEditable) {
                if (isBoolean(isEditable)) {
                    editable = isEditable;
                }
            }
        },
        filesIdCounter: {
            get: function () {
                return filesIdCounter;
            },
            set: function (counter) {
                if (isNumeric(counter)) {
                    filesIdCounter = parseInt(counter);
                }
            }
        },
        selectedFiles: {
            get: function () {
                return selectedFiles;
            }
        },
        checkedFilesMessages: {
            get: function () {
                return checkedFilesMessages;
            }
        },
        allFilesCount: {
            get: function () {
                return allFilesCount;
            },
            set: function (cnt) {
                if (isNumeric(cnt)) {
                    allFilesCount = parseInt(cnt);
                }
            }
        },
        allFilesSize: {
            get: function () {
                return allFilesSize;
            },
            set: function (size) {
                if (isNumeric(size)) {
                    allFilesSize = parseInt(size);
                }
            }
        },
        maxFilesCount: {
            get: function () {
                return defaultSettings.maxFilesCount;
            },
            set: function (cnt) {
                if (isNumeric(cnt)) {
                    defaultSettings.maxFilesCount = parseInt(cnt);
                }
            }
        },
        maxPostSize: {
            get: function () {
                return defaultSettings.maxPostSize;
            },
            set: function (cnt) {
                if (isNumeric(cnt)) {
                    defaultSettings.maxPostSize = parseInt(cnt);
                }
            }
        },
        maxFileSize: {
            get: function () {
                return defaultSettings.maxFileSize;
            },
            set: function (cnt) {
                if (isNumeric(cnt)) {
                    defaultSettings.maxFileSize = parseInt(cnt);
                }
            }
        },
        disabledExtensions: {
            get: function () {
                return defaultSettings.disabledExtensions;
            }
        },
        allowedExtensions: {
            get: function () {
                return defaultSettings.allowedExtensions;
            }
        },
        preUpload: {
            get: function () {
                return defaultSettings.preUpload;
            },
            set: function (isPreUpload) {
                if (isBoolean(isPreUpload)) {
                    defaultSettings.preUpload = isPreUpload;
                }
            }
        },
        uploadUrl: {
            get: function () {
                return defaultSettings.uploadUrl;
            },
            set: function (url) {
                defaultSettings.uploadUrl = url;
            }
        },
        messages: {
            get: function () {
                return defaultSettings.messages;
            }
        }
    });

};

AbstractFileUploader.prototype.findFileByName = function (name) {

    let searchedIndex = -1;

    this.selectedFiles.forEach(function (file, i) {
        let baseName = file.name.replace(/\\/g, '/').replace(/.*\//, '');
        if (name.normalize() === baseName.normalize()) {
            searchedIndex = i;
        }
    });

    return searchedIndex;
};

AbstractFileUploader.prototype.findFileById = function (id) {

    let searchedIndex = -1;

    this.selectedFiles.forEach(function (file, i) {
        if (file.id === parseInt(id)) {
            searchedIndex = i;
        }
    });

    return searchedIndex;
};

AbstractFileUploader.prototype.checkFile = function (file, callback) {

    let fileData = getFileInfo(file);

    if (this.disabledExtensions.indexOf(fileData.extension) !== -1) {
        this.checkedFilesMessages.push(str_replace(this.messages.extensionNotAllowed, "\{file\}", fileData.basename));
        callback(false);
        return;
    }

    if (this.allowedExtensions.indexOf(fileData.extension) === -1) {
        this.checkedFilesMessages.push(str_replace(this.messages.extensionNotAllowed, "\{file\}", fileData.basename));
        callback(false);
        return;
    }

    if (this.findFileByName(fileData.basename) !== -1) {
        this.checkedFilesMessages.push(str_replace(this.messages.fileAlreadySelected, "\{file\}", fileData.basename));
        callback(false);
        return;
    }

    if (file.size > this.maxFileSize) {
        this.checkedFilesMessages.push(str_replace(this.messages.fileSizeExceeded, "\{file\}", fileData.basename));
        callback(false);
        return;
    }

    if (this.allFilesCount + 1 > this.maxFilesCount) {
        this.checkedFilesMessages.push(this.messages.maxFilesCountExceeded);
        callback(false);
        return;
    }

    if (this.allFilesSize + fileData.size > this.maxPostSize) {
        this.checkedFilesMessages.push(this.messages.maxPostSizeExceeded);
        callback(false);
        return;
    }

    let self = this;
    if (fileData.extension.match(/jpg|jfif|gif|png|jpeg|webp|svg/gi)) {

        loadImageFromFile(file, function (img) {
            if (img === null) {
                self.checkedFilesMessages.push('Obrázek: ' + fileData.basename + ' se nepodařilo načíst, a proto byl přeskočen. Pravděpodobně je poškozený');
                callback(false);
            } else {
                callback(true);
            }
        });

    } else {
        callback(true);
    }

};

AbstractFileUploader.prototype.checkFiles = function (files, index, callback) {

    if (files.length === index) {
        callback(true, index);
        return;
    }

    let self = this;
    let currentIndex = index;

    this.checkFiles(files, index + 1, function (res, index) {
        if (currentIndex === index - 1) {

            let file = files[currentIndex];
            self.checkFile(file, function (fileRes) {
                if (fileRes) {
                    file.id = self.filesIdCounter;
                    self.selectedFiles.push(file);
                    self.filesIdCounter += 1;
                    self.allFilesCount++;
                }
                callback(res, index - 1);
            });

        }
    });

};

AbstractFileUploader.prototype.setFiles = function (files, callback) {

    if (!this.input.prop('multiple')) {
        this.selectedFiles.length = 0;
    }

    let self = this;

    this.checkFiles(files, 0, function (res) {

        if (self.checkedFilesMessages.length) {
            self.checkedFilesMessages.forEach(function (msg) {
                toastr.warning(msg);
            });
            self.checkedFilesMessages.length = 0;
        }

        callback(res);

    });

};

AbstractFileUploader.prototype.removeFile = function (id) {

    let index = this.findFileById(id);

    if (index !== -1) {
        let file = this.selectedFiles[index];
        this.allFilesCount -= 1;
        this.allFilesSize -= file.size;
        this.selectedFiles.splice(index, 1);

        return true;
    }

    return false;
};

AbstractFileUploader.prototype.clear = function () {

    this.allFilesSize = 0;
    this.allFilesCount = 0;
    this.selectedFiles.length = 0;

    let inputClone = this.input.clone(true);
    inputClone.val('');

    let currentInput = this.input;
    currentInput.replaceWith(inputClone);

    this.setInput(inputClone);
};

AbstractFileUploader.prototype.loadFileImagePreview = function (file, callback) {

    let fileInfo = getFileInfo(file);

    if (fileInfo.extension.match(/jpg|jfif|gif|png|jpeg|webp|svg/gi)) {
        loadImageFromFile(file, function (imgTag) {
            imgTag.alt = fileInfo.basename;
            callback(imgTag);
        });
    } else {

        let fileImagePreviewPath = BASE_PATH + '/' + FILES_TYPES_IMAGES_PATH;
        let imgTag = new Image();
        imgTag.alt = fileInfo.basename;

        $.get(fileImagePreviewPath + '/' + fileInfo.extension + '.png').done(function () {
            imgTag.src = fileImagePreviewPath + '/' + fileInfo.extension + '.png';
            callback(imgTag);
        }).fail(function () {
            imgTag.src = fileImagePreviewPath + '/unknown.png';
            callback(imgTag);
        });

    }

};

// Uploader input

const FileUploaderInput = function (inputElement, settings) {
    AbstractFileUploader.call(this, inputElement, settings);
};

FileUploaderInput.prototype = Object.create(AbstractFileUploader.prototype);

FileUploaderInput.prototype.getBody = function () {
    return this.container.find(".uploader-body");
};

FileUploaderInput.prototype.adjustInput = function () {
    this.input.attr('style', 'width: 100%; height: ' + getContainerHeight(this.container) + 'px !important');
};

FileUploaderInput.prototype.renderArea = function () {
    let previewsTarget = this.getBody().find('.uploader-previews');

    if (this.selectedFiles.length) {
        previewsTarget.removeClass('placeholder');
        previewsTarget.html(this.messages.selectedFile.replace('{count}', 1));
    } else {
        previewsTarget.addClass('placeholder');
        previewsTarget.html(this.messages.selectSingleFile);
    }
};

FileUploaderInput.prototype.init = function () {

    if (isDefined(this.input.data('instance'))) {
        return;
    }

    this.input.wrap('<div class="inp-wrap file-uploader"><div class="uploader-body"></div></div>');
    this.container = this.input.closest('.file-uploader');

    let body = this.container.find('.uploader-body');
    body.prepend('<div class="uploader-previews"></div>');
    //body.append('<div class="navbar options-bar transparent displ-none"><div class="navbar-body"><div class="navbar-group"><div class="navbar-item icon-link"><a class="uploader-edit option rounded"><i class="fa fa-edit"></i></a></div></div></div></div>');

    this.renderArea();
    this.adjustInput();
    this.input.data('instance', this);
};

$(document).on("change", '.inp-file-basic', function (e) {

    let instance = $(this).data('instance');

    if (isDefined(instance)) {
        instance.setFiles(this.files, function () {
            instance.renderArea();
        });
    }

});

// Uploader editor

const FileUploaderEditor = function (inputElement, settings) {
    AbstractFileUploader.call(this, inputElement, settings);
};

FileUploaderEditor.prototype = Object.create(AbstractFileUploader.prototype);

FileUploaderEditor.prototype.getBody = function () {
    return this.container.find(".uploader-body");
};


FileUploaderEditor.prototype.setEnableEdit = function (enable) {

    let body = this.getBody();
    let content = body.find('.uploader-content');
    let navbars = body.find(".uploader-previews").find(".navbar");

    if (enable) {
        content.find('input[type="file"]').last().hide();
        navbars.removeClass("displ-none");
        this.editable = true;
    } else {
        content.find('input[type="file"]').last().show();
        navbars.addClass("displ-none");
        this.editable = false;
    }

};

FileUploaderEditor.prototype.adjustInput = function () {
    this.input.attr('style', 'width: 100%; height: ' + getContainerHeight(this.getBody()) + 'px !important');
};

FileUploaderEditor.prototype.renderFileTile = function (shifter, editable, renderAgain, callback) {

    shifter.i -= 1;
    let currentIndex = shifter.i;

    if (shifter.i < 0) {
        callback(null, null, currentIndex);
        return;
    }

    let self = this;
    this.renderFileTile(shifter, editable, renderAgain, function (tile, file, index) {

        callback(tile, file, index);

        if (currentIndex === index + 1) {

            let currentFile = self.selectedFiles[currentIndex];

            if (!isBoolean(currentFile.tileRendered) || renderAgain) {

                let fileData = getFileInfo(currentFile);

                self.loadFileImagePreview(currentFile, function (imgTag) {

                    callback($(`
                            <div class="preview editor preview-${currentFile.id}">
                                <div class="navbar spread single-item ${self.editable ? "" : " displ-none"}">
                                    <div class="navbar-body">
                                        <div class="navbar-group">
                                            <div class="navbar-item">
                                                <a href="#" data-id="${currentFile.id}" class="option preview-remove" title="Odebrat soubor">
                                                    <i class="fa fa-times"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="edit-content">
                                    ${$(imgTag).fadeIn().prop('outerHTML')}
                                    <div class="preview-title">
                                        <span>${fileData.basename}</span>
                                    </div>
                                </div>
                            </div>
                        `), currentFile, currentIndex);

                });

            } else {
                callback(null, null, currentIndex);
            }

        }

    });

};

FileUploaderEditor.prototype.renderFilesPreviews = function (previewsTarget, renderAgain) {

    renderAgain = renderAgain | false;

    if (!previewsTarget.find(".tiles-previews").length) {
        previewsTarget.append('<div class="tiles-previews"></div>');
    }

    previewsTarget.find(".table-previews").hide();

    let tilesPreviews = previewsTarget.find(".tiles-previews");
    tilesPreviews.show();

    let shifter = {
        i: this.selectedFiles.length
    };

    let self = this;
    this.renderFileTile(shifter, this.editable, renderAgain, function (tile, file) {
        if (tile !== null) {

            tilesPreviews.append(tile);

            tile.find(".preview-remove").on("click", function (e) {
                e.preventDefault();
                self.removeFile(file.id, previewsTarget);
            });

            // TODO preUpload progress

            file.tileRendered = true;
            self.adjustInput();
        }
    });

};

FileUploaderEditor.prototype.renderArea = function () {

    let previewsTarget = this.getBody().find('.uploader-previews');

    if (this.selectedFiles.length) {
        previewsTarget.find(".choose-file").remove();
        this.renderFilesPreviews(previewsTarget);
    } else {
        previewsTarget.html('<div class="choose-file"><div class="title align-center"><span>' + this.messages.selectFiles + '</span></div>');
    }

};

FileUploaderEditor.prototype.enableEdit = function (enable = true) {

    let navbars = this.getBody().find(".uploader-previews .tiles-previews .navbar");

    if (enable) {
        navbars.removeClass('displ-none');
        this.input.hide();
    } else {
        navbars.addClass('displ-none');
        this.input.show();
    }


};

FileUploaderEditor.prototype.clearPreviews = function () {
    this.getBody().find(".uploader-previews").html("");
};

FileUploaderEditor.prototype.removeFile = function (id, previewsDest) {

    AbstractFileUploader.prototype.removeFile.call(this, id);

    let self = this;
    previewsDest.find(".preview-" + id + "").fadeOut(300, function () {
        $(this).remove();
        self.adjustInput();
    });

};

FileUploaderEditor.prototype.clear = function () {
    AbstractFileUploader.prototype.clear.call(this);
    this.clearPreviews();
    this.adjustInput();
};

FileUploaderEditor.prototype.init = function () {

    if (isDefined(this.input.data('instance'))) {
        return;
    }

    if (!window.File && !window.FileList && !window.FileReader) {
        return;
    }

    this.input.wrap('<div class="editor file-uploader"><div class="edit-content"><div class="uploader-body"><div class="uploader-content"></div></div></div></div>');
    this.container = this.input.closest('.file-uploader');

    this.container.prepend(`
        <div class="navbar editor-theme uploader-options">
            <div class="navbar-body">
                <div class="navbar-group single-active">
                    <div class="navbar-item icon-item">
                        <a href="#" class="uploader-edit option" title="Editovat soubory">
                            <i class="fa fa-edit fa-editor"></i>
                        </a>
                    </div>
                </div>
                ${/*<div class="navbar-group single-active">
                    <div class="navbar-item icon-item">
                        <a class="uploader-tiles option active" title="Zobrazit dlaždice">
                            <img src="${PATHS.icons}/graphics.png" alt="graphics">
                        </a>
                    </div>
                    <div class="navbar-item icon-item">
                        <a class="uploader-table option" title="Zobrazit tabulku">
                            <img src="${PATHS.icons}/table.png" alt="table">
                        </a>
                    </div>
                </div>*/''}
            </div>
        </div>
    `);

    this.container.find('.uploader-body').prepend('<div class="uploader-previews"></div>');

    this.renderArea();

    let self = this;
    this.container.optimusEditor(function (option, isActive) {
        if (option.hasClass("uploader-edit")) {
            self.enableEdit(isActive);
        }/* else if (option.hasClass("uploader-tiles")) {
            uploaderInstance.switchMode("tiles");
        } else if (option.hasClass("uploader-table")) {
            uploaderInstance.switchMode("table");
        }*/
    });

    this.adjustInput();
    this.input.data('instance', this);

};

$(document).on("change", '.inp-file-extended', function (e) {

    if (!$(e.target).is('.uploader-previews')) {

        let instance = $(this).data('instance');

        if (isDefined(instance)) {
            instance.setFiles(this.files, function () {
                instance.renderArea();
            });
        }

    }

});

$(document).on("drop", '.inp-file-extended', function (e) {

    let instance = $(this).data('instance');
    e.preventDefault();

    if (isDefined(instance)) {
        instance.setFiles(e.originalEvent.dataTransfer.files, function () {
            instance.renderArea();
        });
    }

});


/*

const FileRenderer = function () {

    var loadImagePreview = function (file, callback) {
        var fileInfo = getFileInfo(file);
        if(fileInfo.extension.match(/jpg|jfif|gif|png|jpeg|webp/gi)){
            loadImageFromFile(file, function (img) {
                callback(img);
            });
        } else {
            var image_url = PATHS.icons + "/";
            var image = "file.png";
            var img = new Image();
            img.height = 250;
            img.src = image_url + image;
            callback(img);
        }
    };

    this.renderTableRow = function (file, editable) {
        var fileInfo = getFileInfo(file);
        return '<tr class="preview preview-'+file.id+' editor-row">' +
            '<td class="preview-title"><span>' + fileInfo.basename + '</span></td>' +
            '<td>' + fileInfo.size.toFixed(2) + ' MB</td>' +
            '<td class="progress-cell"></td>'+
            '<td class="shrink preview-options editor-options '+(editable ? "" : "displ-none")+'"><div class="options-bar transparent"><div class="group"><a data-id="'+file.id+'" class="option preview-remove"><i class="fa fa-remove"></i></a></div></div>' +
            '</td>' +
            '</tr>';
    };
};

const Uploader = function(settings) {

    this.switchMode = function (mode) {
        previewType = mode;
        this.renderArea(this.moveToBody(input).find(".uploader-previews"));
    };

    var uploadFile = function (progressArea, file, callback) {

        var progressBar = $.progressBar.insert(progressArea);

        var formData = new FormData();
        formData.append(input.attr("name"), file);

        $.nette.ajax({
            xhr: function () {
                let xhr = new window.XMLHttpRequest;

                xhr.upload.addEventListener('progress', function(e) {
                    if (e.lengthComputable) {
                        let percentComplete = e.loaded / e.total;
                        $.progressBar.update(progressBar, Math.round(percentComplete * 100));
                    }
                }, false);

                return xhr;
            },
            type: "POST",
            url: default_settings.uploadUrl,
            data: formData,
            processData: false,
            contentType: false,
            success: function () {
                $.progressBar.remove(progressBar);
                callback(true);
            }
        });

    };

    this.renderPreviews = function (previewsTarget, renderAgain) {

        renderAgain = renderAgain | false;

        var self = this;
        var fileRenderer = new FileRenderer();

        switch (previewType) {
            case "tiles":


                break;
            case "table":

                if(!previewsTarget.find(".table-previews").length){
                    previewsTarget.append('<div class="table-previews"></div>');
                }
                previewsTarget.find(".tiles-previews").hide();
                var tablePreviews = previewsTarget.find(".table-previews");
                tablePreviews.show();

                var content;

                if (tablePreviews.html() === "") {
                    content = $('<table class="editor"><tbody></tbody></table>');
                    tablePreviews.append(content);
                } else {
                    content = tablePreviews.find(".block");
                }

                $.each(filesToUpload, function (i, file) {
                    if (!isBoolean(file.tableRendered) || renderAgain) {
                        var row = $(fileRenderer.renderTableRow(file, editable));
                        content.find("table tbody").append(row);
                        var progressTarget = row.find(".progress-cell");

                        if (default_settings.preUpload) {
                            if(!isBoolean(file.uploaded)) {
                                uploadFile(progressTarget, file, function (result) {
                                    if(result){
                                        var msgGroup = $.inlineMessages.createGroup(progressTarget);
                                        $.inlineMessages.insertMessage(msgGroup, "Nahráno");
                                        self.adjustInput();
                                    }
                                });
                            } else {
                                var msgGroup = $.inlineMessages.createGroup(progressTarget);
                                $.inlineMessages.insertMessage(msgGroup, "Nahráno");
                            }
                        }

                        row.find(".preview-remove").on("click", function (e) {
                            self.removeFile(file.id, previewsTarget);
                        });

                        self.adjustInput();
                        file.tableRendered = true;
                    }
                });

                this.adjustInput();

                break;
            default:
                console.log("wrong uploader render type in graphicsRenderer");
                break;
        }

    };

    this.renderArea = function (previewsTarget) {

        previewsTarget.find(".choose-file").remove();

        if (default_settings.rendererType === "basic") {
            if (filesToUpload.length > 0) {
                previewsTarget.text("Vybráno " + filesToUpload.length + " souborů");
                previewsTarget.parent().find(".options-bar").removeClass("displ-none");
            } else {
                previewsTarget.text("Vyberte soubor/y");
                previewsTarget.parent().find(".options-bar").addClass("displ-none");
            }
        } else {

        }

    };

};

*/


(function ($) {

    $.fn.inputFileUpload = function () {

        $(this).each(function () {
            let input = $(this);

            let inputFileEditor = new FileUploaderEditor(input, input.data('limits'));
            inputFileEditor.init();
        });

        /*
        if (!isDefined(input.data("instance"))) {

            var uploaderInstance;

            switch (settings.rendererType) {
                case "basic":
                    let body = input.closest(".uploader-body");
                    if (!input.closest(".uploader-body").length) {
                        input.wrap('<div class="uploader-body"></div>');
                        body = input.closest(".uploader-body");
                    }
                    if (!body.closest(".inp-uploader-wrap").length) {
                        body.wrap('<div class="inp-wrap inp-uploader-wrap file-uploader"></div>');
                    }
                    body.prepend('<div class="uploader-previews">Vyberte soubor/y</div>');
                    body.append('<div class="navbar options-bar transparent displ-none"><div class="navbar-body"><div class="navbar-group"><div class="navbar-item icon-link"><a class="uploader-edit option rounded"><i class="fa fa-edit"></i></a></div></div></div></div>');

                    uploaderInstance = new Uploader($.extend(input.data("limits"), settings));
                    uploaderInstance.setInput(input);

                    body.find(".uploader-edit").on("click", function (e) {
                        e.preventDefault();
                        var btn = $(this);
                        new BasicDialog({
                            bar: {
                                title: "Editace souborů"
                            },
                            content: " ",
                            event: e,
                            buttonPointer: btn,
                            classes: {
                                container: "basic-uploader-dialog"
                            }
                        }, function (dialog, dialogInstance) {
                            body = dialogInstance.moveToBody(dialog);
                            uploaderInstance.enableEdit(true);
                            uploaderInstance.renderPreviews(body, true);
                        });
                    });

                    break;
                case "graphics":



                    break;
            }

            return uploaderInstance;

        } else {
            return input.data("instance");
        }
        */

    };

})(jQuery);
